import { RefreshCw, AlertTriangle } from 'lucide-react'
import { Capacitor } from '@capacitor/core'

interface Props {
  /** Soft nudge: new version available, user can dismiss or refresh */
  updateAvailable: boolean
  /** Hard block: server requires upgrade (426) */
  upgradeRequired: boolean
  onRefresh: () => void
}

export default function UpdateBanner({ updateAvailable, upgradeRequired, onRefresh }: Props) {
  if (!updateAvailable && !upgradeRequired) return null

  const isNative = Capacitor.isNativePlatform()

  if (upgradeRequired) {
    return (
      <div className="bg-rose/15 border-b border-rose/30 px-4 py-3 flex items-center gap-3">
        <AlertTriangle size={18} className="text-rose shrink-0" />
        <p className="text-sm text-ivory flex-1">
          {isNative
            ? 'This version is no longer supported. Please update the app.'
            : 'This version is no longer supported. Please refresh to continue.'}
        </p>
        <button
          onClick={onRefresh}
          className="text-sm font-medium text-gold hover:text-gold-light transition-colors shrink-0"
        >
          {isNative ? 'Update' : 'Refresh'}
        </button>
      </div>
    )
  }

  return (
    <div className="bg-gold/10 border-b border-gold/20 px-4 py-2.5 flex items-center gap-3">
      <RefreshCw size={16} className="text-gold shrink-0" />
      <p className="text-sm text-cream flex-1">A new version is available.</p>
      <button
        onClick={onRefresh}
        className="text-sm font-medium text-gold hover:text-gold-light transition-colors shrink-0"
      >
        Refresh
      </button>
    </div>
  )
}
